export enum TagSearchOrder {
  OrderByTagId = 1,
  OrderByTag = 2,
}

export enum TagType {
  Email = 1,
  Contact = 2,
}
